import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="Container">
            <img className="p-5 img-fluid" src="https://i.ibb.co/990HYZz/Untitled-design-37.png" alt="" />
        </div>
    );
};

export default NotFound;